import { FC } from "react";
import { Link } from "react-router-dom";

interface Props {
  name: string;
  leftSidebar: boolean;
}

const Logo: FC<Props> = ({ name, leftSidebar }) => {
  return (
    <div className="logo">
      <Link to="/" className="logo-link">
        {leftSidebar ? (
          <img src="/img/logo.svg" style={{ width: "39px" }} alt="Isnet" />
        ) : (
          <img src="/img/logo.svg" width="150px" alt="Isnet" />
        )}
      </Link>
    </div>
  );
};

export default Logo;
